import { coursesAction } from './course-slice'
import { studyGroupsApi } from '../utils'
import { throwApiError } from '../components/lms-shared/store/error-handling-actions';
import { ParticipantTypeEnumText } from '../models/ParticipantTypeEnum'

export const fetchCoursesData = () => {

  return async (dispatch, getState) => {
    const state = getState();
    const studyGroupsRangeFilter = {
      applicationId: state.application.applicationId,
      participantType: ParticipantTypeEnumText.teacher
    }
    studyGroupsApi.studyGroupsFilterRangePost({ studyGroupsRangeFilter }, (error, resdata, response) => {

      if (error) {
        dispatch(throwApiError({ userMessage: state.translate.texts.studyGroupsFilterError, error: error, statusCode: response?.statusCode, message: "studyGroupsFilterRangePost " + error.message, level: 1, component: "course-actions", line: 28 }))
      }
      else {
        //TODO change response.body to resdata
        dispatch(coursesAction.init(response.body.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)).map(d => ({ ...d }))))
      }
    })
  }
}
